import CategoryTabs from "@/components/feature/CategoryTabs";
import { categoryList } from "@/mocks/site";

const statusOptions = [
  { key: "all", label: "全部状态" },
  { key: "ongoing", label: "持续追踪" },
  { key: "progress", label: "有进展" },
  { key: "concluded", label: "已有结论" },
];

interface EventFiltersProps {
  category: string;
  status: string;
  query: string;
  onCategoryChange: (value: string) => void;
  onStatusChange: (value: string) => void;
  onQueryChange: (value: string) => void;
}

export default function EventFilters({
  category,
  status,
  query,
  onCategoryChange,
  onStatusChange,
  onQueryChange,
}: EventFiltersProps) {
  return (
    <div className="w-full px-5 md:px-10 py-6 md:py-8">
      <div className="flex flex-col lg:flex-row lg:items-center gap-5 lg:gap-6">
        <div className="flex-1 min-w-0">
          <CategoryTabs
            categories={categoryList.map((c) => ({ key: c.key, name: c.name }))}
            active={category}
            onChange={onCategoryChange}
          />
        </div>

        <div className="flex flex-col sm:flex-row gap-3 lg:shrink-0">
          <div className="relative">
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-sm" />
            <input
              type="search"
              value={query}
              onChange={(e) => onQueryChange(e.target.value)}
              placeholder="搜索事件标题或关键词"
              aria-label="搜索事件"
              className="w-full sm:w-64 text-sm pl-9 pr-3.5 py-2.5 rounded-md border border-background-300 bg-background-50 text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
            />
          </div>

          <select
            value={status}
            onChange={(e) => onStatusChange(e.target.value)}
            aria-label="按状态筛选"
            className="w-full sm:w-36 text-sm px-3.5 py-2.5 rounded-md border border-background-300 bg-background-50 text-foreground-800 focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-200 cursor-pointer"
          >
            {statusOptions.map((opt) => (
              <option key={opt.key} value={opt.key}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
}